var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3166 0.818359H1.50177C1.32399 0.818359 1.20548 0.877619 1.08696 0.996137C0.968439 1.11466 0.90918 1.23317 0.90918 1.41095V2.89243C1.73881 3.60354 3.51659 5.02577 6.30177 7.21836L6.59807 7.51466C7.07214 7.92947 7.4277 8.22577 7.72399 8.34429C8.19807 8.64058 8.55362 8.81836 8.84992 8.81836C9.14622 8.81836 9.56103 8.64058 9.97585 8.34429C10.2129 8.16651 10.6277 7.87021 11.1018 7.51466L11.4573 7.21836C14.1833 5.02577 16.0203 3.60354 16.8499 2.89243V1.41095C16.8499 1.23317 16.7907 1.11466 16.6721 0.996137C16.6129 0.877619 16.4944 0.818359 16.3166 0.818359Z",
    fill: "#294764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8721 8.34408C11.2796 8.81816 10.8647 9.17371 10.5092 9.35149C9.91659 9.70705 9.38325 9.88483 8.90918 9.88483C8.43511 9.88483 7.90177 9.70705 7.30918 9.35149C6.95362 9.11445 6.47955 8.81816 5.94622 8.34408L5.59066 8.04779C3.33881 6.21075 1.73881 4.96631 0.90918 4.31445V11.6033C0.90918 11.7811 0.968439 11.8996 1.08696 12.0182C1.20548 12.1367 1.32399 12.1959 1.50177 12.1959H16.3166C16.4944 12.1959 16.6129 12.1367 16.7314 12.0182C16.8499 11.8996 16.9092 11.7811 16.9092 11.6033V4.31445C16.0795 4.96631 14.5388 6.21075 12.2277 8.04779L11.8721 8.34408Z",
    fill: "#294764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailDark);
export default __webpack_public_path__ + "static/media/mail_dark.75711105247ca99ca1076c03ccb67a82.svg";
export { ForwardRef as ReactComponent };